<template>
  <router-view />
</template>

<script setup lang="ts">
// 已移除 VideoPreviewDialog，视频现在直接在表格中使用 video 标签播放
</script>

<style lang="scss">
@use './styles/global.scss';
</style>